import(/* webpackMode: "eager" */ "/app/apps/platform-web/app/talent/error.tsx");
